var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "save-wrapper-component",
    {
      attrs: {
        "max-width": "500px",
        name: _vm.name,
        title: _vm.siteProjectsSrv.project.id
          ? _vm.$t("Dialogs.AddSiteProject.EditSiteProject")
          : _vm.$t("Dialogs.AddSiteProject.AddSiteProject"),
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function ({ invalid }) {
            return [
              _c(
                "base-btn",
                {
                  attrs: { disabled: invalid },
                  on: {
                    click: function ($event) {
                      return _vm.siteProjectsSrv.save(_vm.siteId)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Common.Save")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "div",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("base-text-field", {
                    attrs: {
                      rules: "required",
                      value: _vm.siteProjectsSrv.project.title,
                      name: "title",
                      label: _vm.$t("Fields.Common.ProjectTitle.Label"),
                    },
                    on: {
                      "update:value": function ($event) {
                        return _vm.$set(
                          _vm.siteProjectsSrv.project,
                          "title",
                          $event
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("base-date-picker", {
                    attrs: {
                      format: false,
                      value: _vm.siteProjectsSrv.project.startDate,
                      label: _vm.$t("Fields.Common.StartDate.Label"),
                    },
                    on: {
                      "update:value": function ($event) {
                        return _vm.$set(
                          _vm.siteProjectsSrv.project,
                          "startDate",
                          $event
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("base-date-picker", {
                    attrs: {
                      format: false,
                      value: _vm.siteProjectsSrv.project.endDate,
                      label: _vm.$t("Fields.Common.EndDate.Label"),
                    },
                    on: {
                      "update:value": function ($event) {
                        return _vm.$set(
                          _vm.siteProjectsSrv.project,
                          "endDate",
                          $event
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }